<template>
  <div class="product-details-color" v-if="colors.length>1">
    <span>Color :</span>
    <ul>
      <li v-for="product in colors" >
        <a :href="'/fashion-handbags/'+product.productCategoryName+'/'+product.productSn" :title="product.name"  class="product-item-image-inner">
          <img :src="product.pic" :class="product.productSn===productSn?'img-thumbnail border-success':'img-thumbnail'" :title="product.color" style="width: 60px;">
        </a>
      </li>
    </ul>
  </div>
  <div class="product-details-color" v-else-if="colors.length==1">
    <span>Color : {{colors[0].color}}</span>
  </div>
</template>

<script>
    import request from '@/utils/request'
    export default {
        name: "color",
        props:{
          productSn:{
            type:String,
            default:""
          }
        },
        data(){
          return {
            colors:[]
          }
        },
        watch:{
          productSn:function(newVal,oldVal){
            let _this = this
            if(newVal!=''){
              let reg = new RegExp("large-size","g");
              request({
                url:"/product/colors/"+newVal,
                method:"GET"
              }).then(res=>{
                if(res.data.code===200) {
                  _this.colors = res.data.data
                  _this.colors.forEach((item, index) => {
                    item.pic = item.pic.replace(reg, 'thumbnail-size')
                  })
                }
              })
            }
          }
        }
    }
</script>

<style scoped>

</style>
